import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TrashIcon, ModalControl, LeafIcon } from '@paygreen/paygreen-ui';
import { ModalControlClose } from '../../components';

const ActionsCell = ({ t, selectedProductData, setModalData }) => {
    const actionIconProps = {
        iconSize: 'sm',
        colorPallet: 'status',
        hasBackground: true,
        hasHover: true,
    };

    const handleChange = (mode) => {
        setModalData({
            productData: selectedProductData,
            mode: mode,
            openMatching: mode === 'edit' ? true : false,
        });
    };

    return (
        <>
            <ModalControl>
                <ModalControlClose action={() => handleChange('edit')}>
                    <LeafIcon
                        htmlTag="button"
                        title={t('matching.table.associate')}
                        marginRight="md"
                        marginBottom="sm"
                        {...actionIconProps}
                        colorStatus="success"
                    />
                </ModalControlClose>

                <ModalControlClose action={() => handleChange('delete')}>
                    <TrashIcon
                        htmlTag="button"
                        title={t('matching.table.delete')}
                        {...actionIconProps}
                        colorStatus="danger"
                    />
                </ModalControlClose>
            </ModalControl>
        </>
    );
};

ActionsCell.propTypes = {
    selectedProductData: PropTypes.object,
    setModalData: PropTypes.func,
};

export default withTranslation('common')(ActionsCell);
